import React, { useEffect, useState } from "react";
import { Container, Row, Col, ProgressBar, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "@popperjs/core/dist/umd/popper.min.js";

import { LoadingSpinner } from "../../Shared";
import { CurriculumCoverageAccordion, NavigationBar } from "../../../helper";
import * as BigPictureApi from "../../../api/bigPictureApi.js";
import { styles } from "../../SchoolAdmin";
import { setSelect } from "../../../store/stylesSlice.js";

import "../../../assets/stlyes/BigPicture/CurriculumCoverage.scss";
import { ClassHomeCheckBox } from "../../Classes/classHomeCheckBox.js";

const CurriculumAccordion = (props) => {
  const { subjects, setSubjects } = props;
  const _subjects = subjects.filter(sub => sub.isChecked).map(sub => sub.subject)
  const [curriculumCoverageData, setCurriculumCoverageData] = useState({})
  const [loader, setLoader] = useState(false)
  const [openAccordionIndex, setOpenAccordionIndex] = useState(0);
  const dispatch = useDispatch();
  dispatch(setSelect(NavigationBar.BigPicture));


  useEffect(() => {
    getCurriculumCoverage()
  }, [])

  const getCurriculumCoverage = async () => {
    setLoader(true)
    const _curriculumCoverageData = (await BigPictureApi.getCurriculumCoverage()).Items
    Object.keys(_curriculumCoverageData).forEach(data => {
      _curriculumCoverageData[data].year = _curriculumCoverageData[data].year.map(ele => ({ year: ele.year, percentageMarked: ele.percentageMarked })).reverse();
      _curriculumCoverageData[data]._class = _curriculumCoverageData[data]._class.map(ele => ({ className: ele.className, percentageMarked: ele.percentageMarked })).reverse();
      setCurriculumCoverageData(_curriculumCoverageData)
    })
    setLoader(false)
  }

  const handleAccordionClick = (index) => {
    setOpenAccordionIndex(index === openAccordionIndex ? -1 : index);
  };

  return (
    loader ? <LoadingSpinner /> : <div className="accordion curriculum-Accordion" id="accordionExample">
      <ClassHomeCheckBox
        page="Coverage"
        subjects={subjects}
        setSubjects={setSubjects}
      />
      {_subjects.map((subject, index) => (
        <div className={`accordion-item ${subject}`} key={index}>
          <h2 className={`accordion-header ${subject}-accordion-header`}>
            <button
              className={`${subject}-accordion-button accordion-button ${index === 0 ? "" : "collapsed"}`}
              type="button"
              onClick={() => handleAccordionClick(index)}
              data-bs-toggle="collapse"
              data-bs-target={`#collapse${index + 1}`}
              aria-expanded={index === 0 ? "true" : "false"}
              aria-controls={`collapse${index + 1}`}
            >
              {subject}
              <FontAwesomeIcon
                icon={faChevronUp}
                className={`accordion-icon ${openAccordionIndex === index ? "" : "rotate"}`}
              />
            </button>
          </h2>
          <div id={`collapse${index + 1}`} className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`} data-bs-parent="#accordionExample">
            <Container className="accordion-body">
              <Row className="d-flex">
                <Col style={{ minWidth: "420px" }}>
                  <h1 className="yearGroup">{CurriculumCoverageAccordion.YearGroup}</h1>
                  <div style={{ position: "relative" }}>
                    {curriculumCoverageData[subject]?.year.map((item, i) => (<Row key={i}>
                      <Col sm={3} className="d-flex justify-content-start align-items-end">
                        <OverlayTrigger placement="top" overlay={<Tooltip> <span>{`${item.year.toUpperCase()}`}</span></Tooltip>}><span style={styles.ProgressBarCCTitle}>{`${item.year.toUpperCase()}`}</span></OverlayTrigger>
                      </Col>
                      <Col style={styles.progressBarLeftBorder} sm={9}>
                        <ProgressBar style={styles.progressBarCC}>
                          {<ProgressBar style={{ borderRadius: "0 10px 10px 0", backgroundColor: i % 2 === 0 ? CurriculumCoverageAccordion[`${subject}ColourHigh`] : CurriculumCoverageAccordion[`${subject}ColourLow`] }} key={i} now={item.percentageMarked.split("%")[0]} />}
                          <span style={styles.percentageMarkedCC}>{item.percentageMarked}</span>
                        </ProgressBar>
                      </Col>
                    </Row>))}
                  </div>
                </Col>
                <Col style={{ minWidth: "420px" }}>
                  <h1 className="yearGroup">{CurriculumCoverageAccordion.ClassGroup}</h1>
                  <div style={{ position: "relative" }}>
                    {curriculumCoverageData[subject]?._class.map((item, i) => (<Row key={i}>
                      <Col sm={3} className="d-flex justify-content-start align-items-end">
                        <OverlayTrigger placement="top" overlay={<Tooltip> <span>{`${item.className.toUpperCase()}`}</span></Tooltip>}><span style={styles.ProgressBarCCTitle}>{`${item.className.toUpperCase()}`}</span></OverlayTrigger>
                      </Col>
                      <Col sm={9} className="CCNew" style={styles.progressBarLeftBorder}>
                        <ProgressBar style={styles.progressBarCC}>
                          {<ProgressBar style={{ borderRadius: "0 10px 10px 0", backgroundColor: i % 2 === 0 ? CurriculumCoverageAccordion[`${subject}ColourHigh`] : CurriculumCoverageAccordion[`${subject}ColourLow`] }} key={i} now={item.percentageMarked.split("%")[0]} />}
                          <span style={styles.percentageMarkedCC}>{item.percentageMarked}</span>
                        </ProgressBar>
                      </Col>
                    </Row>))}
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      ))}
    </div>
  );
};

export { CurriculumAccordion };
